import { render } from "./industrialBrain.vue?vue&type=template&id=77d96985&scoped=true"
const script = {}

import "./industrialBrain.vue?vue&type=style&index=0&id=77d96985&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77d96985"]])

export default __exports__